"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactRedux = require("react-redux");
var _redux = require("redux");
var _exchangeUiPortalsStore = require("@mulesoft/exchange-ui-portals-store");
var _arrays = require("@mulesoft/exchange-ui-portals-store/lib/utils/arrays");
var _exchangeReactHooks = require("@mulesoft/exchange-react-hooks");
var _AssetCard = _interopRequireDefault(require("./AssetCard"));
var _constants = require("../constants");
var mapStateToProps = function mapStateToProps(state) {
  var _ref = state.common || {},
    homeQuery = _ref.homeQuery;
  var statuses = (0, _arrays.convertToArray)(homeQuery === null || homeQuery === void 0 ? void 0 : homeQuery.status);
  var highlightedStatus = statuses.length === 1 ? statuses[0] : null;
  var isRemoveMulesoftOrgReviewsEnabled = _exchangeUiPortalsStore.selectors.selectFeatureFlag(state, _constants.REMOVE_MULESOFT_ORG_REVIEWS_ENABLED);
  return {
    highlightedStatus: highlightedStatus,
    isRemoveMulesoftOrgReviewsEnabled: isRemoveMulesoftOrgReviewsEnabled
  };
};
var ComposedAssetCard = (0, _redux.compose)(_exchangeReactHooks.withConfig, (0, _reactRedux.connect)(mapStateToProps, null, null, {
  context: _exchangeReactHooks.RootStoreContext
}))(_AssetCard.default);
ComposedAssetCard.styles = _AssetCard.default.styles;
var _default = exports.default = ComposedAssetCard;
//# sourceMappingURL=AssetCard.container.js.map